import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import HelpTooltip from "@/shared/components/help-tooltip";
import ToggleTab from "@/shared/components/toggle-tab";
import { useRecoilState, useSetRecoilState } from "recoil";
import { markupSectionStore } from "@/features/dashboard/features/markup-trend-section/store/markup-section-store";

export default function MarkupTrendHeader() {
  const { t, tSentence, tTitle } = useI18nHelper();
  const [markupTrendType, setMarkupTrendType] =
    useRecoilState(markupSectionStore);
  const handleToggle = (index: number) => {
    setMarkupTrendType(index === 0 ? "SEASON" : "STOCK");
  };
  return (
    <Flex justifyContent={"space-between"} width={"100%"}>
      <Flex gap={"2px"} alignItems={"center"}>
        <Text textStyle={"body-lg-bold"}>{t("markup_trend_by_brand")}</Text>
        <HelpTooltip
          text={tSentence("markup_trend_by_brand_tooltip")}
          iconsSize={20}
        />
      </Flex>
      <ToggleTab
        leftText={t("navigation.pre_order")}
        rightText={tTitle("common\:markup_chart_stock")}
        onChange={handleToggle}
        index={markupTrendType ? (markupTrendType === "SEASON" ? 0 : 1) : 0}
      />
    </Flex>
  );
}
